(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["localization-selector"] && !Shopify.designMode) return;
  try {
    document.addEventListener('submit', (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement)) return;
  const selector = form.closest('[data-gc-preserve-location]');
  const option = event.submitter;
  if (!selector || !(option instanceof HTMLButtonElement)) return;
  const currentRoot = (selector.dataset.gcCurrentRoot || '/').replace(/\/$/, '');
  const nextRoot = (option.dataset.gcLocaleRoot || '').replace(/\/$/, '');
  if (!option.hasAttribute('data-gc-locale-root')) return;
  let path = window.location.pathname;
  if (currentRoot && (path === currentRoot || path.startsWith(currentRoot + '/'))) {
    path = path.slice(currentRoot.length) || '/';
  }
  const destination = new URL(nextRoot + path + window.location.search + window.location.hash, window.location.origin);
  if (destination.origin !== window.location.origin) return;
  event.preventDefault();
  window.location.assign(destination.href);
}, true);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["oh-logo-motion-control"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('oh-logo-motion')) {
    customElements.define('oh-logo-motion', class extends HTMLElement {
      connectedCallback() {
        if (this.button || !CSS.supports('selector(:has(*))')) return;
        this.strip = this.closest('.oh-logo-strip');
        this.button = this.querySelector('button');
        if (!this.strip || !this.button) return;
        this.toggleMotion = () => {
          const paused = !this.strip.hasAttribute('data-oh-logo-paused');
          this.strip.toggleAttribute('data-oh-logo-paused', paused);
          this.button.setAttribute('aria-label', paused ? this.button.dataset.playLabel : this.button.dataset.pauseLabel);
        };
        this.button.addEventListener('click', this.toggleMotion);
        this.strip.setAttribute('data-oh-logo-ready', '');
      }
      disconnectedCallback() {
        this.button?.removeEventListener('click', this.toggleMotion);
        this.button = null;
        this.strip = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
